/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { AiOutlineFileText } from 'react-icons/ai';
import { displayDocVersion, ROUTES } from '../../assets/constants/strings';
import { FaChevronRight } from 'react-icons/fa';
import { BsFillFolderSymlinkFill } from 'react-icons/bs';

const PaginatedList = ({
  DisplayList,
  handleSetDocument,
  selectedItem,
  handleSelectedLevel,
  isSearch = false,
  searchValue = '',
}) => {
  const [itemsPerPage] = useState(10);
  const [selectedPage, setSelectedPage] = useState(1);

  const handlePaginationClick = (item) => {
    setSelectedPage(item.selected + 1);
  };

  const pageCount = Math.ceil(DisplayList.length / itemsPerPage);
  const indexOfLastItem = selectedPage * itemsPerPage;
  const indexOfFirstTodo = indexOfLastItem - itemsPerPage;
  const selectedList = DisplayList.slice(indexOfFirstTodo, indexOfLastItem);

  const documentList = isSearch
    ? DisplayList.sort((a, b) =>
        a.title.trim().localeCompare(b.title.trim(), undefined, {
          numeric: true,
        })
      ).slice(indexOfFirstTodo, indexOfLastItem)
    : DisplayList.filter((item) => item.itemType === 'Document')
        .sort((a, b) =>
          a.Document.title
            .trim()
            .localeCompare(b.Document.title.trim(), undefined, {
              numeric: true,
            })
        )
        .slice(indexOfFirstTodo, indexOfLastItem);

  useEffect(() => {
    setSelectedPage(1);
  }, [DisplayList]);

  const highlightText = (html, query) => {
    if (query === '') {
      // If the query is empty, return the original HTML content
      return html;
    }

    const regex = new RegExp(`(${query})`, 'gi');
    const parts = html.split(/(<[^>]*>)/); // Split HTML content into text and HTML parts

    for (let i = 0; i < parts.length; i++) {
      if (i % 2 === 0) {
        // Text parts
        parts[i] = parts[i].replace(
          regex,
          '<span class="highlighted">$1</span>'
        );
      }
    }

    return parts.join(''); // Combine text and HTML parts back together
  };

  return isSearch ? (
    <div
      style={{
        padding: '0 2rem 1rem 1rem',
      }}
    >
      {selectedList.map((doc, i) => {
        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Link
              key={i}
              to={ROUTES.DOCUMENT(doc.slug)}
              // to={ROUTES.HOME}
              onClick={() => handleSetDocument(doc.slug)}
              className='doc-wrapper__content__list__item'
            >
              <div className='d-flex align-items-center'>
                <AiOutlineFileText className='file-icon' />
                {/* <span>{displayDocVersion(doc)}</span> */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: highlightText(displayDocVersion(doc), searchValue),
                  }}
                />
              </div>
            </Link>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                padding: '0 0.5rem',
              }}
            >
              {doc?.levelOne?.Title && (
                <span
                  style={{
                    fontSize: '0.75rem',
                    margin: '0 0.2rem',
                  }}
                >
                  {doc?.levelOne?.Title}
                </span>
              )}
              {doc?.levelTwo?.Title && (
                <span
                  style={{
                    fontSize: '0.75rem',
                    margin: '0 0.2rem',
                  }}
                >
                  / {doc?.levelTwo?.Title}
                </span>
              )}
              {doc?.levelThree?.Title && (
                <span
                  style={{
                    fontSize: '0.75rem',
                    margin: '0 0.2rem',
                  }}
                >
                  / {doc?.levelThree?.Title}
                </span>
              )}
              {doc?.levelFour?.Title && (
                <span
                  style={{
                    fontSize: '0.75rem',
                    margin: '0 0.2rem',
                  }}
                >
                  / {doc?.levelFour?.Title}
                </span>
              )}
            </div>
            <br />
          </div>
        );
      })}
      {pageCount > 1 && (
        <div className='text-center mt-3 pb-4 mx-auto'>
          <ReactPaginate
            onPageChange={handlePaginationClick}
            previousLabel={'previous'}
            previousClassName={'paginate-previous'}
            nextLabel={'next'}
            nextClassName={'paginate-next'}
            breakLabel={'...'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            containerClassName={'pagination pagination-sm'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            activeClassName={'page-item active'}
          />
        </div>
      )}
    </div>
  ) : (
    <div className='doc-wrapper__content__list'>
      {selectedList.length > 0 ? (
        <React.Fragment>
          {selectedList
            .filter((item) => item.itemType === 'LevelItem')
            // .sort((a, b) => (a.LevelItem.Sort > b.LevelItem.Sort ? 1 : -1))
            .sort((a, b) =>
              a.LevelItem.Title.localeCompare(b.LevelItem.Title, undefined, {
                numeric: true,
              })
            )
            .map(({ LevelItem }, i) => {
              return (
                <div
                  key={i}
                  onClick={() => handleSelectedLevel(LevelItem)}
                  className={`doc-wrapper__content__list__item${
                    selectedItem && selectedItem.ID === LevelItem.ID
                      ? ' item-active'
                      : ''
                  }`}
                >
                  <div className='d-flex align-items-center'>
                    <BsFillFolderSymlinkFill className='file-icon' />
                    <span>{LevelItem.Title}</span>
                  </div>
                  <FaChevronRight className='arrow-icon' />
                </div>
              );
            })}
          {documentList.map(({ Document }, i) => {
            return (
              <Link
                key={i}
                to={ROUTES.DOCUMENT(Document.slug)}
                // to={ROUTES.HOME}
                onClick={() => handleSetDocument(Document.slug)}
                className='doc-wrapper__content__list__item'
              >
                <div className='d-flex align-items-center'>
                  <AiOutlineFileText className='file-icon' />
                  <span>{displayDocVersion(Document)}</span>
                </div>
              </Link>
            );
          })}
          {pageCount > 1 && (
            <div className='text-center mt-3 pb-4 mx-auto'>
              <ReactPaginate
                onPageChange={handlePaginationClick}
                previousLabel={'previous'}
                previousClassName={'paginate-previous'}
                nextLabel={'next'}
                nextClassName={'paginate-next'}
                breakLabel={'...'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={10}
                containerClassName={'pagination pagination-sm'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                activeClassName={'page-item active'}
              />
            </div>
          )}
        </React.Fragment>
      ) : (
        // if there isn't
        <div
          className='alert alert-danger'
          role='alert'
          aria-label='No Documents'
        >
          No matching documents found.
        </div>
      )}
    </div>
  );
};

export default PaginatedList;
